module.exports = __webpack_public_path__ + "img/red_bg.b48bfdda.png";